import { generateNewTabName } from './generateNewTabName'

export const openNewTab = url => {
  window.open(url, generateNewTabName())
}
